export enum ProcessReportSetting {
  RespondentsAnonymity = 1,
  ResponsesAnonymity = 2,
  CompareComparisonGroup = 4,
  ShowRespondentsGradeChart = 8,
  ShowRespondentsCategoryChart = 16
}